import { createSelector } from '@reduxjs/toolkit';

import { getResponseDataOrEmptyArray } from '@bvi/api-interfaces/response';
import { ICompanySizeListResponse } from '@bvi/api-interfaces/response/company-size';

export const selectCompanySizes = createSelector(
  (response?: ICompanySizeListResponse) => response,
  (response) => getResponseDataOrEmptyArray(response),
);
